<script lang="javascript">
	import {onMount, tick} from 'svelte';
	import {fade} from 'svelte/transition';
    import { selectedPostData } from "../../stores/stores.js";

	export let positionObject = undefined;
    export let postData = undefined;
    export let handlePOITouch = () => {};

    $:imgPath = postData.image + '?w=320&h=180&crop=1';

    let tiptool;
    let focused = false;
    let ready = false;
    const defaultColor = '#4A48D6';

    const getPercentage = (value) => {
        return value * 100 + '%';
    };

    const isTouchDevice = () => {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
           ((typeof navigator.msMaxTouchPoints !== 'undefined') && (navigator.msMaxTouchPoints > 0)));
    }

    const isTouchScreen =  isTouchDevice();

    $:xPos = positionObject ? getPercentage(positionObject.x) : getPercentage(0.5);
    $:yPos = positionObject ? getPercentage(positionObject.y) : getPercentage(0.5);
    $:color = positionObject && positionObject.color && positionObject.color.includes('#') ? positionObject.color : defaultColor;
    
    const handleMouseEnter = async (e) => {
        if (isTouchScreen) return; 
        focused = true;
        await tick();
        const tiptoolTop = tiptool.offsetHeight + 15;
        tiptool.style.top = '-' + tiptoolTop + 'px';
    };
    
    const onClick = (e) => {
        if (isTouchScreen) return;
        if (postData) {
            location.href = postData.url;
        }
    };

    const handleMouseLeave = (e) => {
        if (isTouchScreen) return;
        focused = false;
    };

    const handleTouchStart = (e) => {
        handlePOITouch(postData);
    };

    onMount(() => {
        ready = true;
    });

</script>

<div class="absolute {focused ? 'z-[210]' : 'z-10'}" style="left: {xPos}; top: {yPos}" on:mouseleave={handleMouseLeave} >
	{#if ready}
    <div transition:fade={{ delay: Math.random() * 1800, duration: 400 }} class="absolute rounded-none">
        <a 
            href={postData.url} 
            style="background-color: {color}" 
            class="z-10 absolute -top-3 -left-3 w-6 h-6 lg:-top-5 lg:-left-5 lg:w-10 lg:h-10 rounded-full" 
            on:click|preventDefault={onClick} 
            on:touchstart={handleTouchStart} 
            on:mouseenter={handleMouseEnter} >
            <span class="sr-only">"{postData.title}"</span>
        </a>
        <span style="background-color: {color}" class="absolute -top-5 -left-5 w-10 h-10 lg:-top-7 lg:-left-7 lg:w-14 lg:h-14 rounded-full opacity-50"></span>
        <span style="background-color: {color}" class="absolute -top-7 -left-7 w-14 h-14 lg:-top-9 lg:-left-9 lg:w-[72px] lg:h-[72px] rounded-full opacity-30"></span>
    </div>
    {/if}
    {#if focused}
        <div 
        bind:this={tiptool}
        transition:fade={{ delay: 10, duration: 300 }}
        class="absolute drop-shadow-lg bottom-arrow z-10 top-0 w-60 left-[-7.5rem] bg-white" 
        >
        <div class="p-4">
            <div class="mb-2 text-base/tight font-headline font-bold text-black text-left">{postData.title}</div>
            <div class="aspect-video bg-gray-200">
                <img class="w-full" src={imgPath} alt={postData.image_alt || postData.title} />
            </div>
        </div>
    </div>
    {/if}
</div>

<style>
.bottom-arrow {
    border-bottom: 5px solid white;
}
.bottom-arrow:after {
    content:'';
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-top: 20px solid white;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
}
</style>